import axiosInstance from '../../axiosConfig';

export async function fetchDocumentationIndex() {
    const { data } = await axiosInstance.get('/api/docs');
    return Array.isArray(data?.docs) ? data.docs : [];
}

export async function fetchDocumentationDoc(docId) {
    const { data } = await axiosInstance.get(`/api/docs/${encodeURIComponent(docId)}`);
    return data?.doc || null;
}
